import { Component, Vue } from 'vue-property-decorator';
import dayjs from 'dayjs';
import template from './Overview.vue';
import LinearStatistic from '@/components/Usage/Linear';
import CircularStatistic from '@/components/Usage/Circular';

import customer from '@/store/modules/customer';
import store from '@/store';
import { Query, Meta } from '@/store/models';
import auth from '@/store/modules/auth';
import { Customer } from '@/store/models/customer';
import filters from '@/_helpers/filters';
import { router } from '@/_helpers';

@Component({
	mixins: [template],
	components: {
		LinearStatistic,
		CircularStatistic
	},
	methods: {
		formatBytes: filters.formatBytes,
		formatNumber: filters.formatNumber
	}
})
export default class Overview extends Vue {
	loading: boolean = false;

	subscriptions: any = [];

	usage: any = null;

	progress: any = null;

	isDemo: boolean = false;

	public get getCta(): string {
		if (this.progress) {
			if (this.progress.permissionToPay) {
				return 'Betaling regelen';
			}
			if (this.progress.additionalInformation) {
				return 'Pakket kiezen';
			}
			if (this.progress.address) {
				return 'Gegevens aanvullen';
			}
			if (this.progress.verified) {
				return 'Adres toevoegen';
			}
		}

		return 'Registratie afronden';
	}

	async mounted(): Promise<void> {
		this.loading = true;

		await auth.getSelf();

		const query: Query = {
			customerID: auth.self.customerId
		};

		this.getUsage(query);
		this.getSubscription(query);
		this.getProgress();

		this.loading = false;
	}

	get customer(): Customer {
		return customer.customer;
	}

	formatPlanText(currency: string, amount: number, interval: string): string {
		let curr = '';
		switch (currency) {
			case 'eur':
				curr = '€';
				break;
			case 'usd':
				curr = '$';
				break;
			default:
				curr = '€';
				break;
		}

		let inter = '';
		switch (interval) {
			case 'month':
				inter = 'maand';
				break;
			case 'year':
				inter = 'jaar';
				break;
			default:
				inter = 'maand';
				break;
		}

		return `${curr}${amount / 100} per ${inter} (excl. btw)`;
	}

	getDaysLeft(): number {
		return (
			dayjs()
				.endOf('month')
				.diff(dayjs(), 'day') + 1
		);
	}

	async getUsage(query: Query): Promise<void> {
		try {
			const result = await customer.getUsage(query);
			this.usage = result.data;
		} catch (error) {
			store.commit('openNotifier', {
				text: `Er ging wat fout tijdens het ophalen van de gebruikgegevens`,
				color: 'error'
			});
		}
	}

	async getSubscription(query: Query): Promise<void> {
		try {
			const result = await customer.getSubscription(query);

			const subscriptions: any = result.data.filter((subscription: any) => {
				return (
					subscription.items.filter((item: any) => {
						return item.type === 'plan';
					}).length > 0
				);
			});

			if (subscriptions.length === 0) {
				this.isDemo = true;
			}
			this.subscriptions = subscriptions;
		} catch (error) {
			store.commit('openNotifier', {
				text: `Er ging wat fout tijdens het ophalen van de abonnementgegevens`,
				color: 'error'
			});
		}
	}

	async getProgress(): Promise<void> {
		try {
			this.progress = await customer.getProgress();
		} catch (error) {
			store.commit('openNotifier', {
				text: `Er ging wat fout tijdens het ophalen van de voortganggegevens`,
				color: 'error'
			});
		}
	}

	doCurrentRegistrationAction(): void {
		if (this.progress) {
			if (this.progress.additionalInformation) {
				router.push({ name: 'plans' });
			} else if (this.progress.address) {
				router.push({ name: 'details' });
			} else if (this.progress.verified) {
				router.push({ name: 'addressAdd' });
			}
		}
	}
}
